export default __webpack_public_path__ + "static/media/node.dd47e26e.svg";